import clsx from 'clsx';
import { ComponentType, SVGProps } from 'react';

type ScoreChipProps = Readonly<{
  label: string;
  value: number;
  emphasis?: boolean;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  badge?: string;
  className?: string;
}>;

export default function ScoreChip({
  label,
  value,
  emphasis,
  icon: Icon,
  badge,
  className
}: ScoreChipProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-start rounded-lg border px-3 py-2',
        emphasis
          ? 'border-blue-200 bg-blue-50 text-blue-900'
          : 'border-gray-200 bg-white text-gray-900',
        className
      )}
    >
      <div
        className={clsx(
          'flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider',
          emphasis ? 'text-blue-700' : 'text-gray-500'
        )}
      >
        {Icon && <Icon className='h-4 w-4 shrink-0' />}
        <span>{label}</span>
      </div>
      <div className='mt-1 flex items-baseline gap-1'>
        <span
          className={clsx(
            'text-xl font-bold',
            emphasis ? 'text-blue-600' : 'text-gray-900'
          )}
        >
          {Math.round(value)}
        </span>
        <span
          className={clsx(
            'text-xs',
            emphasis ? 'text-blue-400' : 'text-gray-400'
          )}
        >
          /100
        </span>
      </div>
      {badge && (
        <div
          className={clsx(
            'mt-1 inline-flex items-center rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wider',
            emphasis ? 'bg-blue-600 text-white' : 'bg-gray-900 text-white'
          )}
        >
          {badge}
        </div>
      )}
    </div>
  );
}
